import { gql } from '@apollo/client'

export const GET_POSTS_BY_TERRITORY = gql`
  query getPostsByTerritory($territoryId: ID!, $filters: TerritoryMostEngagedFilters, $limit: Int = 1) {
    getTerritory(territoryId: $territoryId) {
      territoryId
      territoryMostEngaged {
        posts(limit: $limit, filters: $filters) {
          _id
          postId
          title
          thumbnail
        }
      }
    }
  }
`
